<template>
  <v-snackbar
    v-model="snackbarVisible"
    :color="color"
    bottom
    :timeout="3000"
  >
    {{ snackbar.text }}
    <v-btn dark text @click="snackbarVisible = false">
      Fechar
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'snackbar',
  data: () => ({
    snackbarVisible: false
  }),
  computed: {
    ...mapGetters(['snackbar']),
    color () {
      return (this.snackbar.color) ? this.snackbar.color : 'default'
    }
  },
  watch: {
    snackbar (val) {
      if (val) this.snackbarVisible = true
    },
    snackbarVisible (val) {
      if (val === false) this.SET_SNACKBAR(false)
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR'])
  }
}
</script>
